import axios from "axios";
import { createContext, useContext, useReducer } from "react";
import About_reducer from "../reducer/About_reducer";
import {
  GET_DIRECTOR_BEGIN,
  GET_DIRECTOR_SUCCESS,
  GET_DIRECTOR_ERROR,
  GET_WHYVISIT_BEGIN,
  GET_WHYVISIT_SUCCESS,
  GET_WHYVISIT_ERROR,
  GET_ABOUTUS_BEGIN,
  GET_ABOUTUS_SUCCESS,
  GET_ABOUTUS_ERROR,
  GET_CONFERENCE_BEGIN,
  GET_CONFERENCE_SUCCESS,
  GET_CONFERENCE_ERROR,
  GET_EXHIBITION_BEGIN,
  GET_EXHIBITION_SUCCESS,
  GET_EXHIBITION_ERROR,
} from "../utils/action";
import {
  ACCEPT_HEADER,
  get_director_url,
  get_whyvisit_url,
  get_aboutus_url,
  get_conference_url,
  get_exhibition_url,
} from "../utils/constant";

const AboutContext = createContext();

const initialState = {
  aboutus_loading: false,
  aboutus_data: {},
  director_loading: false,
  director_data: {},
  exhibition_loading: false,
  exhibition_data: {},
  conference_loading: false,
  conference_data: {},
  whyvisit_loading: false,
  whyvisit_data: {},
};

export const AboutProvider = ({ children }) => {
  const [state, dispatch] = useReducer(About_reducer, initialState);

  // ─── GET ABOUT US ──────────────────────────────────────────────────────────
  const GetAboutUs = async () => {
    dispatch({ type: GET_ABOUTUS_BEGIN });

    axios
      .get(get_aboutus_url, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: GET_ABOUTUS_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_ABOUTUS_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get About Us Api ", err);
        dispatch({ type: GET_ABOUTUS_ERROR });
      });
  };

  // ─── GET DIRECTOR MESSAGE ──────────────────────────────────────────────────
  const GetDirector = async () => {
    dispatch({ type: GET_DIRECTOR_BEGIN });

    axios
      .get(get_director_url, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: GET_DIRECTOR_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_DIRECTOR_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Director Api ", err);
        dispatch({ type: GET_DIRECTOR_ERROR });
      });
  };

  // ─── GET EXHIBITION ────────────────────────────────────────────────────────
  const GetExhibition = async () => {
    dispatch({ type: GET_EXHIBITION_BEGIN });

    axios
      .post(
        get_exhibition_url,
        {},
        {
          headers: {
            Accept: ACCEPT_HEADER,
          },
        },
      )
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: GET_EXHIBITION_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_EXHIBITION_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Exhibition Api ", err);
        dispatch({ type: GET_EXHIBITION_ERROR });
      });
  };

  // ─── GET CONFERENCE ────────────────────────────────────────────────────────
  const GetConference = async () => {
    dispatch({ type: GET_CONFERENCE_BEGIN });

    axios
      .get(get_conference_url, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: GET_CONFERENCE_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_CONFERENCE_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Conference Api ", err);
        dispatch({ type: GET_CONFERENCE_ERROR });
      });
  };

  // ─── GET WHY VISIT ─────────────────────────────────────────────────────────
  const GetWhyVisit = async () => {
    dispatch({ type: GET_WHYVISIT_BEGIN });

    axios
      .get(get_whyvisit_url, {
        headers: {
          Accept: ACCEPT_HEADER,
        },
      })
      .then((res) => {
        if (res.data.success === 1 || res.data.success === true) {
          dispatch({ type: GET_WHYVISIT_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: GET_WHYVISIT_ERROR });
        }
      })
      .catch((err) => {
        console.log("Error in Get Why Visit Api ", err);
        dispatch({ type: GET_WHYVISIT_ERROR });
      });
  };

  return (
    <AboutContext.Provider
      value={{
        ...state,
        GetAboutUs,
        GetDirector,
        GetExhibition,
        GetConference,
        GetWhyVisit,
      }}
    >
      {children}
    </AboutContext.Provider>
  );
};

export const useAboutContext = () => {
  return useContext(AboutContext);
};
